import React from 'react'
import StepOneForm from './StepOneForm'

const StepOne = () => {
  return (
    <div className="w-full">
      <StepOneForm />
    </div>
  )
}

export default StepOne
